import React from "react";
import GameRules from "./GameRules";
import GameLimits from "./GameLimits";
import FreeBets from "./FreeBets";
import ProvablyFairSettings from "./ProvablyFairSettings";
import MyBetsHistory from "./MyBetsHistory";
import ChooseAvatar from "./ChooseAvatar";
import Cookies from 'universal-cookie';

import "./Settings.css";
import { Controller } from "../core/Controller";
import { EVENTS } from "../core/EVENTS";


export default class Settings extends React.Component<Settings.Props, Settings.State>
{
    cookies: Cookies;
    cookieName: string = "aviator-settings";

    constructor(props: Settings.Props)
    {
        super(props);

        this.state = {
            username: Controller.player ? Controller.player.name : "demo",
            avatar: Controller.player ? Controller.getAvatarForUser(Controller.player.id) : "1",
            music: true,
            sound: true,
            animations: true
        }

        this.cookies = new Cookies();
        this.onKeyDown = this.onKeyDown.bind(this);

        console.log("settings - constructor...");
    }

    onKeyDown(e: KeyboardEvent)
    {
        if (e.key == "Escape")
        {
            this.props.close();
            // this.closeLastWindow();
        }
    }

    componentDidMount()
    {
        console.log("settings - mounted...");

        document.addEventListener("keydown", this.onKeyDown);
        EVENTS.on(EVENTS.RESPONSE.PLAYER_UPDATE, this.updatePlayer, this);
        this.updateFromCookies();
    }


    componentWillUnmount()
    {
        document.removeEventListener("keydown", this.onKeyDown);
        EVENTS.off(EVENTS.RESPONSE.PLAYER_UPDATE, this.updatePlayer, this);
    }


    updateFromCookies()
    {
        console.log("Settings - update from cookies")

        let cookieSound = this.cookies.get("aviator-settings-sound");
        let cookieMusic = this.cookies.get("aviator-settings-music");
        let cookieAnimation = this.cookies.get("aviator-settings-animation");
        const sound = cookieSound ? (cookieSound == 1 ? true : false) : true;
        const music = cookieMusic ? (cookieMusic == 1 ? true : false) : true;
        const animation = cookieAnimation ? (cookieAnimation == 1 ? true : false) : true;

        this.setState({
            sound: sound,
            music: music,
            animations: animation
        });

        if (music)
            EVENTS.emit(EVENTS.SETTINGS.MUSIC);

        if (sound)
            EVENTS.emit(EVENTS.SETTINGS.SOUND);

        if (animation)
            EVENTS.emit(EVENTS.SETTINGS.ANIMATION);

    }


    updatePlayer()
    {
        this.setState({
            avatar: Controller.getAvatarForUser(Controller.player.id),
            username: Controller.player.name
        });
    }


    clickChooseAvatar()
    {
        this.props.close();
        app.addWindow(<ChooseAvatar />)
    }


    clickFreeBets()
    {
        this.props.close();
        app.addWindow(<FreeBets />)
    }

    clickProvablyFairSettings()
    {
        this.props.close();
        app.addWindow(<ProvablyFairSettings />)
    }

    clickRules()
    {
        this.props.close();
        app.addWindow(<GameRules />)
    }


    clickMyBets()
    {
        this.props.close();
        app.addWindow(<MyBetsHistory />);
    }


    clickGameLimits()
    {
        this.props.close();
        app.addWindow(<GameLimits />);
    }


    clickMusic()
    {
        const music = !this.state.music;
        this.setState({ music: music });
        this.cookies.set("aviator-settings-music", music ? 1 : 0);
        EVENTS.emit(EVENTS.SETTINGS.MUSIC);
    }

    clickSound()
    {
        const sound = !this.state.sound;
        this.setState({ sound: sound });
        this.cookies.set("aviator-settings-sound", sound ? 1 : 0);
        EVENTS.emit(EVENTS.SETTINGS.SOUND);
    }

    clickAnimation()
    {
        const animation = !this.state.animations;
        this.setState({ animations: animation });
        this.cookies.set("aviator-settings-animation", animation ? 1 : 0);
        EVENTS.emit(EVENTS.SETTINGS.ANIMATION);
    }


    render()
    {
        const lang = window.lang.shared;
        return (
            <div
                id="settings"
                className={"window font_low " + (this.props.show ? "" : "hide")}
            >
                <div className="head">

                    <div className="user">
                        <img
                            src={"gfx/avatars/av-" + this.state.avatar + ".png?version=" + version}
                        />
                        <div
                            className="username"
                        >
                            {this.state.username}
                        </div>
                    </div>

                    <div
                        className="button"
                        onClick={this.clickChooseAvatar.bind(this)}
                    >
                        <div className="icon_avatar"></div>
                        <div className="label">
                            {lang.change}
                            <br />
                            {lang.avatar}
                        </div>
                    </div>

                </div>

                <div className="buttonGroup switcherGroup">

                    <div className="item">
                        <div className="icon_sound"></div>
                        <div className="label">
                            {lang.sound}
                        </div>
                        <label className="radio_switch">
                            <input
                                type="checkbox"
                                checked={this.state.sound}
                                onChange={this.clickSound.bind(this)}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className="item">
                        <div className="icon_music"></div>
                        <div className="label">
                            {lang.music}
                        </div>
                        <label className="radio_switch">
                            <input
                                type="checkbox"
                                checked={this.state.music}
                                onChange={this.clickMusic.bind(this)}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                    <div className="item">
                        <div className="icon_animation"></div>
                        <div className="label">
                            {lang.animation}
                        </div>
                        <label className="radio_switch">
                            <input
                                type="checkbox"
                                checked={this.state.animations}
                                onChange={this.clickAnimation.bind(this)}
                            />
                            <span className="slider"></span>
                        </label>
                    </div>

                </div>

                <div className="buttonGroup">

                    <div
                        className="item"
                        onClick={this.clickFreeBets.bind(this)}
                    >
                        <div className="icon_star"></div>
                        <div className="label">
                            {lang.free_bets}
                        </div>
                    </div>

                    <div className="item"
                        onClick={this.clickProvablyFairSettings.bind(this)}
                    >
                        <div className="icon_fair_grey"></div>
                        <div className="label">
                            {lang.provably_fair_settings}
                        </div>
                    </div>

                    <div className="item"
                        onClick={this.clickRules.bind(this)}
                    >
                        <div className="icon_rules"></div>
                        <div className="label">
                            {lang.game_rules}
                        </div>
                    </div>

                    <div
                        className="item"
                        onClick={this.clickMyBets.bind(this)}
                    >
                        <div className="icon_history_grey"></div>
                        <div className="label">
                            {lang.my_bet_history}
                        </div>
                    </div>

                    <div
                        className="item"
                        onClick={this.clickGameLimits.bind(this)}
                    >
                        <div className="icon_limits"></div>
                        <div className="label">
                            {lang.game_limits}
                        </div>
                    </div>

                </div>

                <div className="footer">
                    <a
                        className="button home"
                        href={params.lobbyurl}
                    >
                        <div className="icon_home"></div>
                        <div className="label">
                            {lang.home}
                        </div>
                    </a>

                </div>

            </div>
        );
    }


}

export namespace Settings
{


    export interface Props
    {
        show: boolean;
        close: () => void;
    }


    export interface State
    {
        username: string;
        avatar: string;
        music: boolean;
        sound: boolean;
        animations: boolean;
    }


}